/* import __COLOCATED_TEMPLATE__ from './freshdesk.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

interface Args {}

export default class StandaloneDeployOverviewFreshdesk extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Overview::Freshdesk': typeof StandaloneDeployOverviewFreshdesk;
    'standalone/deploy/overview/freshdesk': typeof StandaloneDeployOverviewFreshdesk;
  }
}
